import { useMutation } from "@tanstack/react-query";

import { API_URL } from "@/constants/envVariables";
import { fetchApi } from "@/helpers/fetchApi";
import { AppError } from "@/types";

export const useCancelRecovery = () => {
  const mutation = useMutation<
    { cancelled: boolean },
    AppError,
    { receiverId: string; walletId: string }
  >({
    mutationFn: ({ receiverId, walletId }) => {
      return fetchApi(
        `${API_URL}/receivers/${receiverId}/wallets/${walletId}/recovery`,
        {
          method: "PATCH",
          body: JSON.stringify({
            action: "cancel",
          }),
        },
      );
    },
  });

  return {
    ...mutation,
    error: mutation.error as AppError,
  };
};
